import { useEffect } from 'react';

/**
 * Custom hook to lock/unlock body scroll
 * Useful for modals, drawers, and other overlay components
 * When these components are open, the body scroll should be locked (common behavior)
 *
 * @param isLocked - Whether the body scroll should be locked
 *
 * @example
 * ```tsx
 * const MyModal = ({ isOpen }) => {
 *   useBodyScrollLock(isOpen);
 *   return <div>Modal content</div>;
 * };
 * ```
 */
export const useBodyScrollLock = (isLocked: boolean) => {
    useEffect(() => {
        if (isLocked) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        // Cleanup on unmount
        return () => {
            document.body.style.overflow = '';
        };
    }, [isLocked]);
};
